import type {
  SessionsAsset,
  SessionsOpportunity,
  SessionsPresenter,
} from '@carboncopyco/data';
import constate from 'constate';
import { useState } from 'react';
import type { TableTabTypes } from '../EnvironmentDashboard/EnvironmentSessionBreakdown';

type useTableContextProps = {
  tableTab?: TableTabTypes;
};

export const useTableContext = ({ tableTab }: useTableContextProps) => {
  const [opportunities, setOpportunities] = useState<
    Record<SessionsOpportunity['name'], SessionsOpportunity['name']>
  >({});
  const [presenters, setPresenters] = useState<
    Record<SessionsPresenter['email'], SessionsPresenter['name']>
  >({});
  const [demos, setDemos] = useState<Record<string, SessionsAsset['name']>>({});

  return {
    opportunities,
    setOpportunities,
    presenters,
    setPresenters,
    demos,
    setDemos,
    tableTab,
  };
};

export const [TableContextProvider, useTableProps] = constate(useTableContext);
